import module from 'finanzas/module.js'
import template from './template.html'

function FinancesPosicionbancariaEstatusGridComponent ($filter, $interpolate, $q, FinancesPosicionbancariaEstatus, FinancesPosicionbancariaEmpresas) {
  var $ctrl = this,
    orderBy = $filter('orderBy')

  $ctrl.$onChanges = $onChanges
  $ctrl.filtrar = filtrar
  $ctrl.filtro = ''

  function $onChanges (changes) {
    if (changes.idMoneda || changes.fecha) {
      load()
    }

    if (changes.filtro) {
      filtrar()
    }
  }

  function load () {
    var data = FinancesPosicionbancariaEstatus.get($ctrl.idMoneda, $ctrl.fecha)
      .then(function (response) {
        $ctrl.data = response.data.map(function (item) {
          var row = {
            id: item.id,
            id_naturaleza: item.id_naturaleza,
            descripcion: item.descripcion,
          }

          item.empresas.forEach(function (empresa) {
            row[empresa.id_empresa] = empresa.importe
          })

          return row
        })

        $ctrl.data = orderBy($ctrl.data, ['-id_naturaleza', 'id'])
      })

    var columnas = FinancesPosicionbancariaEmpresas.get()
      .then(function (response) {
        $ctrl.columnas = orderBy(response.data, 'descripcion')
      })

    $ctrl.promise = $q.all([data, columnas])
      .then(function () {
        $ctrl.grid = grid()
        filtrar()
      })
  }

  function filtrar () {
    if ($ctrl.grid && $ctrl.grid.api) {
      $ctrl.grid.api.setQuickFilter($ctrl.filtro)
    }
  }

  function grid () {
    return {
      pinnedColumnCount: 1,
      enableColResize: true,
      rowSelection: 'single',
      columnDefs: columnDefs(),
      rowData: $ctrl.data,
      icons: {
        groupExpanded: '<i class="fa fa-fw fa-caret-down"></i>',
        groupContracted: '<i class="fa fa-fw fa-caret-right"></i>',
        headerGroupOpened: '<i class="fa fa-fw fa-caret-left"></i>',
        headerGroupClosed: '<i class="fa fa-fw fa-caret-right"></i>',
      },
      // groupUseEntireRow   : false,
      groupKeys: ['id_naturaleza'],
      // groupHeaders        : true,
      groupDefaultExpanded: true,
      // groupAggFunction    : groupAggFunction,
      groupColumnDef: {
        headerName: 'Concepto',
        field: 'descripcion',
        width: 250,
        minWidth: 100,
        cellRenderer: {
          renderer: 'group',
          padding: 0,
          innerRenderer: conceptoRenderer,
        },
      },
    }
  }

  function columnDefs () {
    var columnas = [
      {
        field: 'id_naturaleza',
        hide: true,
      },
      {
        field: 'descripcion',
        hide: true,
      },
    ]

    $ctrl.columnas.forEach(function (item) {
      columnas.push({
        headerName: item.descripcion,
        field: item.id_empresa,
        width: 90,
        minWidth: 80,
        cellRenderer: currencyRenderer,
        cellStyle: currencyStyle,
      })
    })

    return columnas
  }

  var conceptoRendererTemplate = '<code class="tag" style="line-height:1.5margin-right:4px">{{id}}</code> {{descripcion}}',
    conceptoRendererCompiler = $interpolate(conceptoRendererTemplate)

  function conceptoRenderer (params) {
    if (params.node.group) {
      return params.node.key === 'I' ? 'Ingresos' : 'Egresos'
    } else {
      return conceptoRendererCompiler({id: params.data.id, descripcion: params.data.descripcion})
    }
  }

  var currencyRendererTemplate = '<div align="right"><span float="left">$</span>{{importe | currency: ""}}</div>',
    currencyRendererCompiler = $interpolate(currencyRendererTemplate)

  function currencyRenderer (params) {
    var importe = params.value

    return importe
      ? currencyRendererCompiler({importe: importe})
      : '<div align="right"><span float="left">$</span>-&nbsp&nbsp</div>'
  }

  function currencyStyle (params) {
    var style = {}
    if (params.value < 0)
      style['color'] = 'red'

    if (!isFinite(params.value) || params.value === 0)
      style['color'] = 'rgba(0, 0, 0, 0.5)'

    return style
  }
}

module.component('financesPosicionbancariaEstatusGrid', {
  controller: FinancesPosicionbancariaEstatusGridComponent,
  template,
  bindings: {
    idMoneda: '<',
    fecha: '<',
    filtro: '<',
  },
})



// WEBPACK FOOTER //
// ./src/finanzas/components/posicionbancaria/estatus/grid/component.js